module.exports = __webpack_public_path__ + "img/378-0b8e8e.png";